import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "../views/Sidebar";
import NavbarNav from "../views/NavbarNav";
import AyudaBoton from "../components/AyudaBoton";
import Home from "../views/Home";
import Formularios from "../views/Formularios";
import Comunicados from "../views/Comunicados";
import firebaseApp from "../firebase/credenciales";
import GDocumentos from "./GDocumentos";
import GFirmas from "./GFirmas";
import ModalDeudaPendiente from "../components/ModalDeudaPendiente";
import DPlantillas from "./Dplantillas";
import Plantillas from "./Plantillas";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import Firma from "./FDocumentos";
import PDFSignatureDetector from "./GestionDocumental/PDFSignatureDetector";
import DocsManager from "./docs/DocsManager";
// Gestión de Usuarios
import Usuarios from "./GestionUsuarios/Usuarios";
import UsuariosMasivos from "./GestionUsuarios/UsuariosMasivos";
import GruposEditor from "./GestionUsuarios/GruposEditor";
import GruposMasivos from "./GestionUsuarios/GruposMasivos";
import UsuariosConFirma from "./GestionUsuarios/UsuariosConFirma";
import CentroCostos from "./GestionUsuarios/CentroCostos";
import CecosMasivos from "./GestionUsuarios/CecosMasivos";
import AlertasVencimientos from "./GestionUsuarios/AlertasVencimientos";
import Cumpleanos from "./GestionUsuarios/Cumpleanos";
import ListaNegra from "./GestionUsuarios/ListaNegra";
import AprobacionesNiveles from "./GestionPermisosRoles/AprobacionesNiveles";
import PermisosRoles from "./GestionPermisosRoles/PermisosRoles";
import PermisosPorRol from "./GestionPermisosRoles/PermisosPorRol";
import UsuariosConRoles from "./GestionPermisosRoles/UsuariosConRoles";
import HistorialCambios from "./GestionUsuarios/HistorialCambios";
import ConsumoFirestore from "./ConsumoFirestore/ConsumoFirestore";

// Gestión de Documentos
import Reglamentos from "./GestionDocumental/Reglamentos";
import Documentos from "./GestionDocumental/Documentos";
import Masivos from "./GestionDocumental/Masivos";
import MasivosEliminar from "./GestionDocumental/MasivosEliminar";
import CorreoMasivos from "./GestionDocumental/CorreoMasivo";
import RenombrarBoletas from "./GestionDocumental/RenombrarBoletas";
import DuplicarDocumentoMasivo from "./GestionDocumental/DuplicarDocumentoMasivo";
import GeneradorContratos from "./GestionDocumental/GeneradorContratos";
import ContratosPlantillas from "./GestionDocumental/ContratosPlantillas";
import DescargarDocumentosGestion from "./GestionDocumental/DescargarDocumentosGestion";

// Gestión Onboarding
import Onboarding from "./GestionOnboarding/Onboarding";
import ListaDocumentosDetalle from "./GestionOnboarding/ListaDocumentosDetalle";
import ConfiguracionDocumentos from "./GestionOnboarding/ConfiguracionDocumentos";
import ListaMaestra from "./GestionOnboarding/ListaMaestra";
import EditorCabeceraSGI from "./GestionOnboarding/EditorCabeceraSGI";
import SeguimientoOnboarding from "./GestionOnboarding/SeguimientoOnboarding";
import DeclaracionJurada from "./GestionOnboarding/DeclaracionJurada";
import Solicitud from "./GestionOnboarding/Solicitud";
import GestionMedica from "./GestionOnboarding/GestionMedica";
import EnviarExamenMedico from "./GestionOnboarding/EnviarExamenMedico";
import FichaPersonal from "./GestionOnboarding/FichaPersonal";
import DescargarDocumentos from "./GestionOnboarding/DescargarDocumentos";

// Reclutamiento y Selección
import CurriculumUploadScreen from "./recruiting/CurriculumUploadScreen";
import VacanteFormScreen from "./recruiting/VacanteFormScreen";
import VacantesListScreen from "./recruiting/VacantesListScreen";

// Gestión de Planillas
import Planillas from "./planillas/Planillas";
import ProcesoPlanilla from "./planillas/ProcesoPlanilla";
import Empleados from "./empleados/Empleados";
import EmpleadosMasivos from "./empleados/EmpleadosMasivos";
import ConfiguracionPlanilla from "./planillas/ConfiguracionPlanilla";
import ConfiguracionContable from "./planillas/ConfiguracionContable";
import ConfiguracionRegimen from "./planillas/ConfiguracionRegimen";
import BoletaPago from "./planillas/BoletaPago";
import AsientosContables from "./planillas/AsientosContables";
import ExportacionArchivos from "./planillas/ExportacionArchivos";
import ConfiguracionPdtPlame from "./planillas/ConfiguracionPdtPlame";
import RegimenTrabajo from "./planillas/RegimenTrabajo";
import VisualizarOcurrencias from "./planillas/VisualizarOcurrencias";
import GestionFeriados from "./planillas/GestionFeriados";
import BonoForm from "./planillas/BonoForm";
import OcurrenciasMes from "./planillas/OcurrenciasMes";
import Pagos from "./planillas/Pagos";

import AdelantoSalario from "./planillas/AdelantoSalario";
import GestionContable from "./GestionContable";
import GestionComprasModulo from "./GestionCompras/GestionComprasModulo";
import GestionVentasModulo from "./GestionVentas";
import GestionTesoreriaModulo from "./GestionTesoreria";


// Gestión de Equipos y EPPs
import EntregaActivos from "./GestionEPP/EntregaActivos";
import CatalogoEPPs from "./GestionEPP/CatalogoEPPs";
import EstadisticaEPP from "./GestionEPP/EstadisticaEPP";
import CatalogoEquipos from "./GestionEPP/CatalogoEquipos";
import CatalogoHerramientas from "./GestionEPP/CatalogoHerramientas";
import GestionPrestamos from "./GestionEPP/GestionPrestamos";
import EntregaActivosList from "./GestionEPP/EntregaActivosList";

// Gestión de Ocurrencias
import GestionOcurrencias from "./ocurrencias/GestionOcurrencias";

// Catálogos
import CatalogosLayout from "../views/catalogos/CatalogosLayout";
import AreasScreen from "../views/catalogos/areas/AreasScreen";
import HabilidadesScreen from "../views/catalogos/habilidades/HabilidadesScreen";
import ProfesionesScreen from "../views/catalogos/profesiones/ProfesionesScreen";
import PerfilesScreen from "../views/catalogos/perfiles/PerfilesScreen";

// Gestión de Asistencias
import AsistenciaCoordenadas from "./GestionAsistencias/AsistenciaCoordenadas";
import ReportesAA from "./GestionAsistencias/ReportesAA";
import ConfiguracionAsistencia from "./GestionAsistencias/ConfiguracionAsistencia";
import AprobacionesAsistencia from "./GestionAsistencias/AprobacionesAsistencia";
import ReporteAsistenciaPDF from "./GestionAsistencias/ReporteAsistenciaPDF";
import ExportarMarcacionesExcel from "./GestionAsistencias/ExportarMarcacionesExcel";
import ImportarMarcacion from "./GestionAsistencias/ImportarMarcacion";
import ReporteIngresos from "./GestionAsistencias/ReporteIngresos";
import GestionTransporte from "./GestionAsistencias/GestionTransporte";
import ReporteTrazabilidad from "./GestionAsistencias/ReporteTrazabilidad";
import RolTurnos from "./GestionAsistencias/RolTurnos";
import EventosAsistencia from "./GestionAsistencias/EventosAsistencia";
import TelegramAsistencia, { puedeGenerarCodigosTelegram } from "./GestionAsistencias/TelegramAsistencia";

// Gestión de Ausencias
import VacacionesMasivas from "./GestionAusencias/VacacionesMasivas";
import VacacionesDetalle from "./GestionAusencias/VacacionesDetalle";
import AusenciasDetalle from "./GestionAusencias/AusenciasDetalle";
import IndicadoresAusentismo from "./GestionAusencias/IndicadoresAusentismo";
import TrabajadoresAusentesMes from "./GestionAusencias/TrabajadoresAusentesMes";
import AdminAusencias from "./GestionAusencias/AdminAusencias";
import CalendarioAusencias from "./GestionAusencias/CalendarioAusencias";
import SolicitudAusencia from "./GestionAusencias/SolicitudAusencia";
import DashboardAusencias from "./GestionAusencias/DashboardAusencias";
import ControlPapeletas from "./GestionAusencias/ControlPapeletas";
import AlertasVacaciones from "./GestionAusencias/AlertasVacaciones";
import ImpactoFinanciero from "./GestionAusencias/ImpactoFinanciero";
import IncrementoVacaciones from "./GestionAusencias/IncrementoVacaciones";

// Empresa y Usuario
import Company from "./Company";
import Perfil from "./Perfil";

// Agentes AI
import DocumentosEditor from "./agentes/DocumentosEditor";
import HiroCVProcessor from "../components/agentes/hiro/HiroCVProcessor";
import HiroChat from "../components/agentes/hiro/HiroChat";
import VexaQuoteProcessor from "../components/agentes/vexa/VexaQuoteProcessor";
import AxisChat from "../components/agentes/axis/AxisChat";
import AxioChat from "../components/agentes/axio/AxioChat";
import EchoChat from "../components/agentes/echo/EchoChat";
import NovaChat from "../components/agentes/nova/NovaChat";

// Gestión de Capacitaciones
import DashboardPage from "./GestionCapacitaciones/DashboardPage";
import CursosPage from "./GestionCapacitaciones/CursosPage";
import CrearCursoPage from "./GestionCapacitaciones/CrearCursoPage";
import EditarCursoPage from "./GestionCapacitaciones/EditarCursoPage";
import UsuariosPage from "./GestionCapacitaciones/UsuariosPage";
import AdministradorCursosPage from "./GestionCapacitaciones/AdministradorCursosPage";

// Gestión de Evaluación de Desempeño
import DashboardEvaluacionPage from "./GestionEvaluacionDesempeno/DashboardPage";
import CrearCampanaPage from "./GestionEvaluacionDesempeno/CrearCampanaPage";

import CampanaPage from "./GestionEvaluacionDesempeno/CampanaPage";
import EditarCampanaPage from "./GestionEvaluacionDesempeno/EditarCampanaPage";
import ResultadosPage from "./GestionEvaluacionDesempeno/ResultadosPage";
import ChangePass from "./GestionUsuarios/ChangePass";

// Atención y Servicios
import GestionMesaAyuda from "./MesaAyuda/GestionMesaAyuda";
import GestionLibroReclamaciones from "./LibroReclamaciones/GestionLibroReclamaciones";
import PublicReclamaciones from "./LibroReclamaciones/PublicReclamaciones";

import { checkPermission } from "../functions/checkPermission";

const firestore = getFirestore(firebaseApp);

function Inicio({ usuario }) {
  const [user, setUser] = useState(usuario);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Sincronizar estado local si la prop usuario cambia
  React.useEffect(() => {
    setUser(usuario);
  }, [usuario]);

  // Función helper para rutas comunes
  const renderPerfilRoute = () => (
    <Route path="/perfil" exact={true} element={<Perfil usuario={user} />} />
  );

  // Función para cambiar de empresa (SuperAdmin / Admin Multi-empresa)
  const updateUserCompany = async (newRuc) => {
    try {
      if (!newRuc) return;

      // Actualizar estado local inmediatamente
      const newUser = { ...user, ruc: newRuc, rucEmpresa: newRuc };
      setUser(newUser);

      // Actualizar Firestore para persistencia
      if (user.dni) {
        const userRef = doc(firestore, "users", user.dni);
        await updateDoc(userRef, {
          rucEmpresa: newRuc
        });
      }
    } catch (error) {
      console.error("Error cambiando empresa:", error);
    }
  };

  // Verificación de permisos para rutas
  const tieneAccesoUsuarios = checkPermission(user, "usuarios");
  const tieneAccesoDocumentos = checkPermission(user, "documentos");
  const rawPlanillasPerms = (() => {
    const permisos = user?.permisos;
    if (!permisos || typeof permisos !== "object" || Array.isArray(permisos)) return null;
    const key = Object.keys(permisos).find((k) => {
      const normalized = String(k || "").trim().toLowerCase();
      return normalized === "planillas" || normalized === "planilla";
    });
    return key ? permisos[key] : null;
  })();
  const tienePlanillasEnPermisos =
    rawPlanillasPerms === true ||
    (Array.isArray(rawPlanillasPerms) && rawPlanillasPerms.length > 0) ||
    (rawPlanillasPerms && typeof rawPlanillasPerms === "object" && Object.values(rawPlanillasPerms).some((v) => v === true));
  const tieneAccesoPlanillas =
    tienePlanillasEnPermisos ||
    checkPermission(user, "planillas") ||
    checkPermission(user, "planillas", "EMPLEADOS") ||
    checkPermission(user, "planillas", "EMPLEADOS_MASIVOS") ||
    checkPermission(user, "planillas", "PAGOS") ||
    checkPermission(user, "planillas", "LISTA_PLANILLAS") ||
    checkPermission(user, "planillas", "PLANILLAS");
  const tieneAccesoAsistencia = checkPermission(user, "asistencia");
  const tieneAccesoAusencias = checkPermission(user, "ausencias");
  const tieneAccesoEpps = checkPermission(user, "epps");
  const tieneAccesoRecruiting = checkPermission(user, "recruiting");
  const tieneAccesoOnboarding = checkPermission(user, "onboarding");
  const tieneAccesoAgentes = checkPermission(user, "agentes");
  const tieneAccesoCapacitaciones = checkPermission(user, "capacitaciones");
  const tieneAccesoEvaluaciones = checkPermission(user, "evaluaciones");
  const tieneAccesoAtencion = checkPermission(user, "atencion");
  const tieneAlguno = (modulo, procesos = []) =>
    procesos.some((proceso) => checkPermission(user, modulo, proceso));
  const tieneAccesoGestionContable =
    checkPermission(user, "contabilidad") ||
    tieneAlguno("contabilidad", ["COMPRAS", "FACTURAS", "PAGOS", "COBROS", "TESORERIA", "VENTAS", "PLANILLAS", "PCGE", "LIBROS", "REPORTES"]) ||
    checkPermission(user, "planillas", "CONFIG_CONTABLE") ||
    checkPermission(user, "planillas", "CUENTAS_CONTABLES") ||
    checkPermission(user, "planillas", "PLANILLAS");
  const tieneAccesoGestionCompras =
    checkPermission(user, "compras") ||
    tieneAlguno("compras", ["ORDENES", "PROVEEDORES", "CATALOGO"]);
  const tieneAccesoGestionVentas =
    checkPermission(user, "ventas") ||
    tieneAlguno("ventas", ["ORDENES"]);
  const tieneAccesoGestionTesoreria =
    checkPermission(user, "tesoreria") ||
    tieneAlguno("tesoreria", ["PAGOS", "COBROS", "DIAS_CALLE"]) ||
    checkPermission(user, "contabilidad", "TESORERIA");
  const tieneAccesoEmpleadosPlanilla =
    checkPermission(user, "planillas", "EMPLEADOS") ||
    checkPermission(user, "planillas", "LISTA_PLANILLAS") ||
    checkPermission(user, "planillas", "PLANILLAS") ||
    checkPermission(user, "planillas");
  const tieneAccesoEmpleadosMasivosPlanilla =
    checkPermission(user, "planillas", "EMPLEADOS_MASIVOS") ||
    checkPermission(user, "planillas", "EMPLEADOS");
  const tieneAccesoPagosPlanilla =
    checkPermission(user, "planillas", "PAGOS") ||
    checkPermission(user, "planillas", "EMPLEADOS");


  return (
    <Router>
      {/* Modal de advertencia de deuda pendiente para clientes */}
      <ModalDeudaPendiente usuario={user} />
      
      <NavbarNav usuario={user} updateUserCompany={updateUserCompany} />
      <div className="flex" style={{ position: "relative" }}>
        <button
          type="button"
          className="btn"
          onClick={() => setSidebarCollapsed((prev) => !prev)}
          title={sidebarCollapsed ? "Mostrar menú" : "Ocultar menú"}
          aria-label={sidebarCollapsed ? "Mostrar menú lateral" : "Ocultar menú lateral"}
          style={{
            position: "fixed",
            top: "72px",
            left: sidebarCollapsed ? "12px" : "252px",
            zIndex: 1100,
            width: "46px",
            height: "46px",
            borderRadius: "50%",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "left 0.3s ease",
            background: "#0d6efd",
            color: "#ffffff",
            border: "2px solid #ffffff",
            fontSize: "1.5rem",
            fontWeight: 700,
            boxShadow: "0 6px 16px rgba(0,0,0,0.45)",
            opacity: 0.98,
          }}
        >
          {sidebarCollapsed ? "›" : "‹"}
        </button>

        <div
          style={{
            width: sidebarCollapsed ? "0" : "280px",
            minWidth: sidebarCollapsed ? "0" : "280px",
            overflow: "hidden",
            transition: "width 0.3s ease, min-width 0.3s ease",
          }}
        >
          <div
            style={{
              transform: sidebarCollapsed ? "translateX(-100%)" : "translateX(0)",
              transition: "transform 0.3s ease",
            }}
          >
            <Sidebar usuario={user} />
          </div>
        </div>

        <div className="content-area" style={{ flex: 1, minWidth: 0 }}>
          <Routes>
            {/* Inicio - Siempre accesible si está logueado */}
            <Route path="/" exact={true} element={<Home usuario={user} />} />

          {/* Gestión de Usuarios */}
          {tieneAccesoUsuarios && (
            <>
              {checkPermission(user, "usuarios", "USUARIOS") && (
                <Route path="/usuarios" exact={true} element={<Usuarios usuario={user} />} />
              )}
              {checkPermission(user, "usuarios", "CECOS") && (
                <Route path="/centro-costos" exact={true} element={<CentroCostos usuario={user} />} />
              )}
              {checkPermission(user, "usuarios", "FIRMAS") && (
                <Route path="/usuarios-con-firma" exact={true} element={<UsuariosConFirma usuario={user} />} />
              )}
              {checkPermission(user, "usuarios", "GRUPOS") && (
                <Route path="/grupos" exact={true} element={<GruposEditor usuario={user} />} />
              )}
              {checkPermission(user, "usuarios", "GRUPOS_MASIVOS") && (
                <Route path="/grupos-masivos" exact={true} element={<GruposMasivos usuario={user} />} />
              )}
              {checkPermission(user, "usuarios", "CECOS_MASIVOS") && (
                <Route path="/asignacion-cecos-masivo" exact={true} element={<CecosMasivos usuario={user} />} />
              )}
              {checkPermission(user, "usuarios", "USUARIOS_MASIVOS") && (
                <Route path="/umasivos" exact={true} element={<UsuariosMasivos usuario={user} />} />
              )}
              {checkPermission(user, "usuarios", "USUARIOS_MASIVOS") && (
                <Route path="/changepass" exact={true} element={<ChangePass usuario={user} />} />
              )}
              <Route path="/lista-negra" exact={true} element={<ListaNegra usuario={user} />} />
              {(user.rol === "admin" || user.rol === "superAdmin") && (
                <Route path="/aprobaciones" exact={true} element={<AprobacionesNiveles usuario={user} />} />
              )}
              {(user.rol === "admin" || user.rol === "superAdmin") && (
                <Route path="/permisos-roles" exact={true} element={<PermisosRoles usuario={user} />} />
              )}
              {(user.rol === "admin" || user.rol === "superAdmin") && (
                <Route path="/permisos-por-rol" exact={true} element={<PermisosPorRol usuario={user} />} />
              )}
              <Route path="/historial-cambios" exact={true} element={<HistorialCambios usuario={user} />} />
              {/* Consumo de Firestore: exclusivo del superAdmin */}
              {user.rol === "superAdmin" && (
                <Route path="/consumo-firestore" exact={true} element={<ConsumoFirestore usuario={user} />} />
              )}
            </>
          )}

          {(user.rol === "admin" || user.rol === "superAdmin" || checkPermission(user, "usuarios", "USUARIOS_CON_ROLES")) && (
            <Route path="/permisos-roles/usuarios-con-roles" exact={true} element={<UsuariosConRoles usuario={user} />} />
          )}

          {/* Gestión de Documentos */}
          {tieneAccesoDocumentos && (
            <>
              {checkPermission(user, "documentos", "FORMULARIOS") && (
                <Route path="/formularios" exact={true} element={<Formularios usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "COMUNICADOS") && (
                <Route path="/comunicados" exact={true} element={<Comunicados usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "DOCUMENTOS") && (
                <Route path="/documentos" exact={true} element={<Documentos usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "DESCARGAR_DOCUMENTOS_DOCUMENTAL") && (
                <Route path="/documentos/descargar-documentos" exact={true} element={<DescargarDocumentosGestion usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "CONTRATOS_GENERADOR") && (
                <Route path="/documentos/contratos" exact={true} element={<GeneradorContratos usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "CONTRATOS_PLANTILLAS") && (
                <Route
                  path="/documentos/contratos-plantillas"
                  exact={true}
                  element={<ContratosPlantillas usuario={user} />}
                />
              )}
              {checkPermission(user, "documentos", "BIBLIOTECA") && (
                <Route path="/reglamentos" exact={true} element={<Reglamentos usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "MASIVOS") && (
                <Route path="/masivos" exact={true} element={<Masivos usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "ELIMINAR_MASIVO") && (
                <Route path="/eliminar-masivo" exact={true} element={<MasivosEliminar usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "RENOMBRAR") && (
                <Route path="/renombrar" exact={true} element={<RenombrarBoletas ruc={user.ruc} />} />
              )}
              {checkPermission(user, "documentos", "DUPLICAR_RUC") && (
                <Route path="/duplicar-documento" exact={true} element={<DuplicarDocumentoMasivo usuario={user} ruc={user.ruc} />} />
              )}
              {checkPermission(user, "documentos", "CORREO_MASIVOS") && (
                <Route path="/cmasivos" exact={true} element={<CorreoMasivos usuario={user} />} />
              )}
              {/* Rutas exclusivas SuperAdmin / Admin con permisos específicos */}
              {(user.rol === "superAdmin" || checkPermission(user, "documentos", "GESTION_DOCS")) && (
                <Route path="/documentos/gdocumentos" exact={true} element={<GDocumentos usuario={user} />} />
              )}
              {(user.rol === "superAdmin" || checkPermission(user, "documentos", "GESTION_FIRMAS")) && (
                <Route path="/gfirmas" exact={true} element={<GFirmas usuario={user} />} />
              )}
              {(user.rol === "superAdmin" || checkPermission(user, "documentos", "PLANTILLAS")) && (
                <Route path="/plantillas" exact={true} element={<Plantillas usuario={user} />} />
              )}
              {(user.rol === "superAdmin" || checkPermission(user, "documentos", "DPLANTILLAS")) && (
                <Route path="/dplantillas" exact={true} element={<DPlantillas usuario={user} />} />
              )}
              {(user.rol === "superAdmin" || checkPermission(user, "documentos", "FIRMA")) && (
                <Route path="/firma" exact={true} element={<Firma usuario={user} />} />
              )}
              {checkPermission(user, "documentos", "PLANTILLA_FIRMAS") && (
                <Route path="/signDetector" exact={true} element={<PDFSignatureDetector usuario={user} />} />
              )}
            </>
          )}

          {/* Gestión Onboarding */}
          {tieneAccesoOnboarding && (
            <>
              {checkPermission(user, "onboarding", "DOCUMENTOS") && (
                <Route path="/onboarding" exact={true} element={<Onboarding usuario={user} />} />
              )}
              {checkPermission(user, "onboarding", "CONFIG_DOCS") && (
                <Route path="/ConfiguracionDocumentos" exact={true} element={<ConfiguracionDocumentos usuario={user} />} />
              )}
              {checkPermission(user, "onboarding", "ESTADISTICAS") && (
                <Route path="/ListaDocumentosDetalle" exact={true} element={<ListaDocumentosDetalle usuario={user} />} />
              )}
              {checkPermission(user, "onboarding", "LISTA_MAESTRA") && (
                <>
                  <Route path="/ListaMaestra" exact={true} element={<ListaMaestra usuario={user} />} />
                  <Route path="/onboarding/editor-cabecera" exact={true} element={<EditorCabeceraSGI usuario={user} />} />
                </>
              )}
              {checkPermission(user, "onboarding", "SEGUIMIENTO") && (
                <Route path="/SeguimientoOnboarding" exact={true} element={<SeguimientoOnboarding usuario={user} />} />
              )}
              {checkPermission(user, "onboarding", "DESCARGAR_DOCUMENTOS_ONBOARDING") && (
                <Route path="/onboarding/descargar-documentos" exact={true} element={<DescargarDocumentos usuario={user} />} />
              )}
              {checkPermission(user, "onboarding", "DJ") && (
                <Route path="/dj" exact={true} element={<DeclaracionJurada usuario={user} />} />
              )}
              {checkPermission(user, "onboarding", "SOLICITUD") && (
                <Route path="/solicitud" exact={true} element={<Solicitud usuario={user} />} />
              )}
              {checkPermission(user, "onboarding", "MEDICO_OCUPACIONAL") && (
                <React.Fragment>
                  <Route path="/onboarding/gestion-medica" exact={true} element={<GestionMedica usuario={user} />} />
                  <Route path="/onboarding/enviar-examen-medico" exact={true} element={<EnviarExamenMedico usuario={user} />} />
                </React.Fragment>
              )}
              {checkPermission(user, "onboarding", "FICHA_PERSONAL") && (
                <Route path="/onboarding/ficha-personal" exact={true} element={<FichaPersonal usuario={user} />} />
              )}
            </>
          )}



          {/* Reclutamiento y Selección */}
          {tieneAccesoRecruiting && (
            <>
              {checkPermission(user, "recruiting", "UPLOAD_CV") && (
                <Route path="/CurriculumUpload" exact={true} element={<CurriculumUploadScreen usuario={user} />} />
              )}
              {checkPermission(user, "recruiting", "GESTION_VACANTES") && (
                <Route path="/vacantes" exact={true} element={<VacantesListScreen usuario={user} />} />
              )}
              {checkPermission(user, "recruiting", "CREAR_VACANTE") && (
                <Route path="/vacantes/crear" exact={true} element={<VacanteFormScreen usuario={user} />} />
              )}
              {checkPermission(user, "recruiting", "GESTION_VACANTES") && (
                <Route path="/vacantes/:id" exact={true} element={<VacanteFormScreen usuario={user} />} />
              )}
              {checkPermission(user, "recruiting", "CATALOGOS") && (
                <Route path="/catalogos" element={<CatalogosLayout />}>
                  <Route path="areas" element={<AreasScreen usuario={user} />} />
                  <Route path="habilidades" element={<HabilidadesScreen usuario={user} />} />
                  <Route path="profesiones" element={<ProfesionesScreen usuario={user} />} />
                  <Route path="perfiles" element={<PerfilesScreen usuario={user} />} />
                </Route>
              )}
            </>
          )}

          {/* Gestión de Asistencias */}
          {tieneAccesoAsistencia && (
            <>
              {checkPermission(user, "asistencia", "COORDENADAS") && (
                <Route path="/coordenadas" exact={true} element={<AsistenciaCoordenadas usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "REPORTES") && (
                <Route path="/reportes-asistencia" exact={true} element={<ReportesAA usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "APROBACIONES") && (
                <Route path="/asistencia/aprobaciones" exact={true} element={<AprobacionesAsistencia usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "CONFIGURACION") && (
                <Route path="/config-asistencia" exact={true} element={<ConfiguracionAsistencia usuario={user} />} />
              )}
              {puedeGenerarCodigosTelegram(user) && (
                <Route path="/asistencia/telegram" exact={true} element={<TelegramAsistencia usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "REPORTE_PDF") && (
                <Route path="/AsistenciaPDF" exact={true} element={<ReporteAsistenciaPDF usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "IMPORTAR") && (
                <Route path="/importar-marcacion" exact={true} element={<ImportarMarcacion usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "INGRESOS") && (
                <Route path="/reporte-ingresos" exact={true} element={<ReporteIngresos usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "TRANSPORTE") && (
                <Route path="/gestion-transporte" exact={true} element={<GestionTransporte usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "TRAZABILIDAD") && (
                <Route path="/reporte-trazabilidad" exact={true} element={<ReporteTrazabilidad usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "ROL_TURNOS") && (
                <Route path="/rol-turnos" exact={true} element={<RolTurnos usuario={user} />} />
              )}
              {checkPermission(user, "asistencia", "EVENTOS") && (
                <Route path="/eventos" exact={true} element={<EventosAsistencia usuario={user} />} />
              )}
            </>
          )}

          {/* Gestión de Equipos y EPPs */}
          {tieneAccesoEpps && (
            <>
              {checkPermission(user, "epps", "ASIGNAR") && (
                <>
                  <Route path="/activos/entrega" exact={true} element={<EntregaActivosList usuario={user} />} />
                  <Route path="/activos/entrega/:id" exact={true} element={<EntregaActivos usuario={user} />} />
                </>
              )}
              {checkPermission(user, "epps", "CATALOGO_EPPS") && (
                <Route path="/catalogo_epps" exact={true} element={<CatalogoEPPs usuario={user} />} />
              )}
              {checkPermission(user, "epps", "CATALOGO_EQUIPOS") && (
                <Route path="/catalogo_equipos" exact={true} element={<CatalogoEquipos usuario={user} />} />
              )}
              {checkPermission(user, "epps", "CATALOGO_HERRAMIENTAS") && (
                <Route path="/catalogo_herramientas" exact={true} element={<CatalogoHerramientas usuario={user} />} />
              )}
              {checkPermission(user, "epps", "ESTADISTICA") && (
                <Route path="/estadistica_epps" exact={true} element={<EstadisticaEPP usuario={user} />} />
              )}
              {checkPermission(user, "epps", "PRESTAMOS") && (
                <Route path="/prestamos_activos" exact={true} element={<GestionPrestamos usuario={user} />} />
              )}
            </>
          )}

          {/* Gestión de Ausencias */}
          {tieneAccesoAusencias && (
            <>
              {checkPermission(user, "ausencias", "DASHBOARD") && (
                <Route path="/ausencias/dashboard" exact={true} element={<DashboardAusencias usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "ALERTAS") && (
                <Route path="/ausencias/alertas" exact={true} element={<AlertasVacaciones usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "IMPACTO") && (
                <Route path="/ausencias/impacto-financiero" exact={true} element={<ImpactoFinanciero usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "INCREMENTO") && (
                <Route path="/ausencias/incremento-automatico" exact={true} element={<IncrementoVacaciones usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "VACACIONES_MASIVAS") && (
                <Route path="/ausencias/vacaciones-masivas" exact={true} element={<VacacionesMasivas usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "VACACIONES_DETALLE") && (
                <Route path="/ausencias/vacaciones-detalle" exact={true} element={<VacacionesDetalle usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "DETALLE_AUSENCIAS") && (
                <Route path="/ausencias/ausencias-detalle" exact={true} element={<AusenciasDetalle usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "INDICADORES") && (
                <Route path="/ausencias/indicadores" exact={true} element={<IndicadoresAusentismo usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "AUSENTES_MES") && (
                <Route path="/ausencias/ausentes-mes" exact={true} element={<TrabajadoresAusentesMes usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "ADMIN") && (
                <Route path="/ausencias/admin" exact={true} element={<AdminAusencias usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "CALENDARIO") && (
                <Route path="/ausencias/calendario" exact={true} element={<CalendarioAusencias usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "SOLICITUD") && (
                <Route path="/ausencias/solicitud" exact={true} element={<SolicitudAusencia usuario={user} />} />
              )}
              {checkPermission(user, "ausencias", "CONTROL_PAPELETAS") && (
                <Route path="/ausencias/control-papeletas" exact={true} element={<ControlPapeletas usuario={user} />} />
              )}
            </>
          )}

          {/* Gestión de Planillas */}
          {tieneAccesoPlanillas && (
            <>
              {tieneAccesoEmpleadosPlanilla && (
                <Route path="/empleados" exact={true} element={<Empleados usuario={user} />} />
              )}
              {tieneAccesoPagosPlanilla && (
                <Route path="/pagos" exact={true} element={<Pagos usuario={user} />} />
              )}
              {tieneAccesoEmpleadosMasivosPlanilla && (
                <Route path="/empleados-masivos" exact={true} element={<EmpleadosMasivos usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "PLANILLAS") && (
                <Route path="/planillas" exact={true} element={<Planillas usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "BOLETAS") && (
                <Route path="/boletas-pago" exact={true} element={<BoletaPago usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "REGIMEN") && (
                <Route path="/regimen-trabajo" exact={true} element={<RegimenTrabajo usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "OCURRENCIAS") && (
                <Route path="/ocurrencias" exact={true} element={<VisualizarOcurrencias usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "FERIADOS") && (
                <Route path="/feriados" exact={true} element={<GestionFeriados usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "NUEVA_OCURRENCIA") && (
                <Route path="/ocurrencias/nueva" exact={true} element={<OcurrenciasMes usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "PLANILLAS") && (
                <Route path="/planillas/:id/asientos" exact={true} element={<AsientosContables usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "PLANILLAS") && (
                <Route path="/proceso-planilla/:id" exact={true} element={<ProcesoPlanilla usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "PLANILLAS") && (
                <Route path="/proceso-planilla" exact={true} element={<ProcesoPlanilla usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "CONFIGURACION") && (
                <Route path="/config-planilla" exact={true} element={<ConfiguracionPlanilla usuario={user} />} />
              )}
              {tieneAccesoGestionContable && (
                <>
                  <Route path="/config-contable" exact={true} element={<ConfiguracionContable usuario={user} />} />
                  <Route path="/gestion-contable" exact={true} element={<GestionContable usuario={user} seccion="dashboard" />} />
                  <Route path="/contabilidad/:seccion" element={<GestionContable usuario={user} />} />
                </>
              )}
              {tieneAccesoGestionCompras && (
                <>
                  <Route path="/gestion-compras" element={<GestionComprasModulo usuario={user} seccion="ordenes" />} />
                  <Route path="/gestion-compras/:seccion" element={<GestionComprasModulo usuario={user} />} />
                </>
              )}
              {tieneAccesoGestionVentas && (
                <>
                  <Route path="/gestion-ventas" element={<GestionVentasModulo usuario={user} />} />
                  <Route path="/gestion-ventas/:seccion" element={<GestionVentasModulo usuario={user} />} />
                </>
              )}
              {tieneAccesoGestionTesoreria && (
                <>
                  <Route path="/gestion-tesoreria" element={<GestionTesoreriaModulo usuario={user} />} />
                  <Route path="/gestion-tesoreria/:seccion" element={<GestionTesoreriaModulo usuario={user} />} />
                </>
              )}


              {checkPermission(user, "planillas", "CONFIG_REGIMEN") && (
                <Route path="/config-regimen" exact={true} element={<ConfiguracionRegimen usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "BONOS") && (
                <Route path="/bonos" exact={true} element={<BonoForm usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "ADELANTOS") && (
                <Route path="/adelantos" exact={true} element={<AdelantoSalario usuario={user} />} />
              )}
              {checkPermission(user, "planillas", "EXPORTACION") && (
                <>
                  <Route path="/planillas/:planillaId/exportacion" element={<ExportacionArchivos usuario={user} />} />
                  <Route path="/planillas/exportacion" element={<ExportacionArchivos usuario={user} />} />
                  <Route path="/exportacion-txt" element={<ExportacionArchivos usuario={user} />} />
                  <Route path="/planillas/config-pdt-plame" element={<ConfiguracionPdtPlame usuario={user} />} />
                  <Route path="/planillas/:planillaId/exportacion/afpnet" element={<ExportacionArchivos usuario={user} tipoExportacionInicial="afpnet" />} />
                  <Route path="/planillas/:planillaId/exportacion/plame" element={<ExportacionArchivos usuario={user} tipoExportacionInicial="plame" />} />
                  <Route path="/planillas/:planillaId/exportacion/tregistro" element={<ExportacionArchivos usuario={user} tipoExportacionInicial="tregistro" />} />
                </>
              )}
            </>
          )}

          {/* Agentes AI */}
          {tieneAccesoAgentes && (
            <>
              {checkPermission(user, "agentes", "PROCESADOR") && (
                <Route path="/documentos/procesador" element={<DocumentosEditor usuario={user} />} />
              )}
              {checkPermission(user, "agentes", "HIRO_CV") && (
                <Route path="/documentos/procesador/hiro" element={<HiroCVProcessor ruc={user.ruc} />} />
              )}
              {checkPermission(user, "agentes", "HIRO_CHAT") && (
                <Route path="/documentos/procesador/chat-hiro" element={<HiroChat ruc={user.ruc} />} />
              )}
              {checkPermission(user, "agentes", "VEXA") && (
                <Route path="/documentos/procesador/vexa" exact={true} element={<VexaQuoteProcessor usuario={user} />} />
              )}
              {/* Echo - Comunicaciones */}
              <Route path="/documentos/procesador/chat-echo" exact={true} element={<EchoChat usuario={user} />} />
              
              <Route path="/documentos/procesador/chat-axis" exact={true} element={<AxisChat usuario={user} />} />
              <Route path="/documentos/procesador/chat-axio" element={<AxioChat usuario={user} />} />
              <Route path="/documentos/procesador/chat-nova" element={<NovaChat usuario={user} />} />
            </>
          )}

          {/* Gestión de Capacitaciones */}
          {tieneAccesoCapacitaciones && (
            <>
              {checkPermission(user, "capacitaciones", "DASHBOARD") && (
                <Route path="/capacitaciones/dashboard" exact={true} element={<DashboardPage usuario={user} />} />
              )}
              {checkPermission(user, "capacitaciones", "DASHBOARD") && (
                <Route path="/capacitaciones/administrar" exact={true} element={<AdministradorCursosPage usuario={user} />} />
              )}
              <Route path="/capacitaciones/curso/:cursoId" exact={true} element={<CursosPage usuario={user} />} />
              {checkPermission(user, "capacitaciones", "CREAR_CURSO") && (
                <Route path="/capacitaciones/crear-curso" exact={true} element={<CrearCursoPage usuario={user} />} />
              )}
              {checkPermission(user, "capacitaciones", "CREAR_CURSO") && (
                <Route path="/capacitaciones/editar-curso/:id" exact={true} element={<EditarCursoPage usuario={user} />} />
              )}
              {checkPermission(user, "capacitaciones", "USUARIOS") && (
                <Route path="/capacitaciones/usuarios" exact={true} element={<UsuariosPage usuario={user} />} />
              )}
            </>
          )}

          {/* Gestión de Evaluación de Desempeño */}
          {tieneAccesoEvaluaciones && (
            <>
              {checkPermission(user, "evaluaciones", "DASHBOARD") && (
                <Route path="/evaluaciones" exact={true} element={<DashboardEvaluacionPage usuario={user} />} />
              )}
              {checkPermission(user, "evaluaciones", "CREAR_CAMPANA") && (
                <Route path="/evaluaciones/crear-campana" exact={true} element={<CrearCampanaPage usuario={user} />} />
              )}
              <Route path="/evaluaciones/campana/:campanaid" exact={true} element={<CampanaPage usuario={user} />} />
              {checkPermission(user, "evaluaciones", "CREAR_CAMPANA") && (
                <Route path="/evaluaciones/editar-campana/:campanaid" exact={true} element={<EditarCampanaPage usuario={user} />} />
              )}
              <Route path="/evaluaciones/resultados/:campanaid" exact={true} element={<ResultadosPage usuario={user} />} />
            </>
          )}

          {/* Atención al Cliente y Servicios */}
          {tieneAccesoAtencion && (
            <>
              {checkPermission(user, "atencion", "HELP_DESK") && (
                <Route path="/atencion/mesa-ayuda" exact={true} element={<GestionMesaAyuda usuario={user} />} />
              )}
              {checkPermission(user, "atencion", "RECLAMACIONES") && (
                <Route path="/atencion/reclamaciones" exact={true} element={<GestionLibroReclamaciones usuario={user} />} />
              )}
            </>
          )}

          {/* Ruta Pública para Libro de Reclamaciones (Sin Login) */}
          <Route path="/p/reclamaciones" exact={true} element={<PublicReclamaciones />} />

          {/* Empresa y Usuario (Atajos comunes) */}
          <Route path="/company" exact={true} element={<Company usuario={user} />} />
          <Route path="/docs" exact={true} element={<DocsManager usuario={user} />} />
          {renderPerfilRoute()}

          {/* Manejo de Rutas no Encontradas / No Permitidas */}
          <Route
            path="/alertas-vencimientos"
            element={
              checkPermission(user, "usuarios", "ALERTAS") ? (
                <AlertasVencimientos usuario={user} />
              ) : (
                <Home usuario={user} />
              )
            }
          />
          <Route
            path="/cumpleanos"
            element={
              checkPermission(user, "usuarios", "ALERTAS") ? (
                <Cumpleanos usuario={user} />
              ) : (
                <Home usuario={user} />
              )
            }
          />
          <Route path="*" element={<Home usuario={user} />} />
          </Routes>
          <AyudaBoton usuario={user} />
        </div>
      </div>
    </Router>
  );
}

export default Inicio;
